import React from 'react'
import {
    List,
    Datagrid,
    TextField as TextFieldRa,
    EditButton,
    TextInput,
    SimpleForm,
    Edit,
    BooleanField,
    BooleanInput,
} from 'react-admin'
import { Tab, Tabs } from '@material-ui/core'
import Icon from '@material-ui/icons/Settings'
import { useHistory, useLocation } from 'react-router-dom'
import { PaymentTypesList } from '../paymentTypes/paymentTypes'

export const SettingsIcon = Icon

const PAYMENT_TYPES_TAB = 'formas-de-pagamento'

export const SettingsList = ({ permissions, ...props }) => {
    const location = useLocation()
    const history = useHistory()
    const canManagePaymentTypes = permissions?.includes('sysadmin')
    const currentTab =
        canManagePaymentTypes && location.hash === `#${PAYMENT_TYPES_TAB}`
            ? PAYMENT_TYPES_TAB
            : 'markup'

    const handleTabChange = (_, value) => {
        history.replace({
            ...location,
            hash: value === PAYMENT_TYPES_TAB ? PAYMENT_TYPES_TAB : '',
        })
    }

    return (
        <>
            {canManagePaymentTypes && (
                <Tabs
                    value={currentTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab value="markup" label="Markup" />
                    <Tab value={PAYMENT_TYPES_TAB} label="Formas de pagamento" />
                </Tabs>
            )}
            {currentTab === PAYMENT_TYPES_TAB ? (
                <PaymentTypesList
                    {...props}
                    resource="admin/paymentTypes"
                    basePath="/admin/paymentTypes"
                    hasCreate
                    hasEdit
                    hasList={false}
                    hasShow={false}
                    syncWithLocation={false}
                />
            ) : (
                <MarkupSettingsList {...props} />
            )}
        </>
    )
}

const MarkupSettingsList = (props) => {
    return (
        <List
            {...props}
            exporter={false}
            title="Configurações"
            bulkActionButtons={false}
            perPage={25}
        >
            <Datagrid>
                <TextFieldRa source="markup" label="Valor %" />
                <TextFieldRa source="description" label="Descrição" />
                <TextFieldRa source="type" label="Tipo" />
                <BooleanField source="isIncrement" label="Incrementar" disabled />
                <EditButton label="" />
            </Datagrid>
        </List>
    )
}

export const SettingsEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput
                    label="Valor %"
                    source="markup"
                />
                <TextInput
                    label="Descrição"
                    source="description"
                />
                <BooleanInput source="isIncrement" label="Incrementar" />
            </SimpleForm>
        </Edit>
    )
}
